<template>
  <q-tab-pane name="projects" class="scroll-y" :class="{ 'no-padding':  customerProjects.length === 0 }">
    <div class="row sticky-top q-mb-sm justify-between" v-if="customerProjects.length" v-is-user>
      <q-btn :label="$tc('project', 1)" icon="add" color="gray" flat @click="handleCreateProject"/>
      <q-btn :label="$t('settle_customer_projects')" colror="gray" flat @click="handleSettleCustomerProjects"/>
    </div>

    <q-scroll-area
      v-if="customerProjects.length"
      class="full-width customer-card__tab-scroll"
      :thumb-style="{ width: '5px','background-color': '#555',opacity: 1 }"
    >
      <div class="row gutter-sm">
        <div v-for="project in customerProjects" :key="project.id" class="col-12 col-md-6">
          <project-card :project="project"/>
        </div>
      </div>
    </q-scroll-area>

    <template v-else>
      <div class="row justify-center items-center col-grow q-pt-lg">
        <div class="text-center">
          <img src="~assets/emptystates/projects_empty.svg" height="100px"/>

          <h6 class="q-my-md text-faded">{{ $t('projects_empty') }}</h6>

          <q-btn @click="handleCreateProject" color="primary" class="q-mt-lg" outline>
            {{ $t('create_project') }}
          </q-btn>
        </div>
      </div>
    </template>
    <project-modal ref="createProjectModal" @save="handleSaveProject" :customer="customer"/>
  </q-tab-pane>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ProjectCard from 'components/TimeTracking/Projects/ProjectCard.vue'
  import ProjectModal from 'components/TimeTracking/Projects/ProjectModal.vue'
  import changeCase from 'change-case-object'
  import { createErrorFromResponse } from 'src/utils/error'

  export default {
    props: {
      customer: {
        type: Object,
        required: true
      }
    },

    computed: mapGetters(['activeTeam', 'customerProjects']),

    methods: {
      ...mapActions(['createProject']),

      handleSettleCustomerProjects () {
        this.$router.push({
          name: 'create-invoice',
          params: { teamId: this.activeTeam.id },
          query: {
            projects: this.customerProjects.map(project => project.id),
            grouping: 'summary'
          }
        })
      },

      handleCreateProject () {
        this.$refs.createProjectModal.show()
      },

      handleSaveProject (project) {
        return this.createProject(changeCase.snake(project))
          .catch(createErrorFromResponse)
      }
    },

    components: {
      ProjectCard,
      ProjectModal
    }
  }
</script>
